module.exports = __webpack_public_path__ + "static/media/icomoon.d8dbb08b.svg";